import React, { useEffect, useRef, useState } from 'react';
import { createChart, CandlestickSeries } from 'lightweight-charts';
import { Bars } from 'react-loader-spinner'; // Make sure this is installed


const BinanceOptionsChart = ({ symbol = 'XRP-250704-2.1-C' }) => {
    const [bookLoading, setBookLoading] = useState(true); // add this
    const chartContainerRef = useRef(null);
    const chartRef = useRef(null);
    const seriesRef = useRef(null);

    useEffect(() => {
        // Initialize chart only if container exists
        if (!chartContainerRef.current) return;

        // Create chart instance
        chartRef.current = createChart(chartContainerRef.current, {
            width: chartContainerRef.current.clientWidth,
            height: 400,
            layout: {
                background: { color: '#17171a' },
                textColor: '#DDD',
            },
            grid: {
                vertLines: { color: '#333' },
                horzLines: { color: '#ffffff00' },
            },
            timeScale: {
                timeVisible: true,
                secondsVisible: false,
            },
        });

        // Add candlestick series - using the correct v4+ method
        seriesRef.current = chartRef.current.addSeries(CandlestickSeries, {
            upColor: '#26a69a',
            downColor: '#ef5350',
            borderVisible: false,
            wickUpColor: '#26a69a',
            wickDownColor: '#ef5350',
        });

        // Handle window resize
        const handleResize = () => {
            if (chartRef.current && chartContainerRef.current) {
                chartRef.current.applyOptions({
                    width: chartContainerRef.current.clientWidth,
                });
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            if (chartRef.current) {
                chartRef.current.remove();
            }
        };
    }, []);

    const [interval, setInterval] = useState('1m');
    const [isConnected, setIsConnected] = useState(false);
    const [lastUpdate, setLastUpdate] = useState(null);

    useEffect(() => {
        if (!seriesRef.current) return;

        const ws = new WebSocket(
            `wss://nbstream.binance.com/eoptions/ws/${symbol}@kline_3d`
        );

        console.log(`wss://nbstream.binance.com/eoptions/ws/${symbol.toLowerCase()}@kline_1m`);
        console.log(ws);
        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);

                if (!data?.k) return;

                const candle = data.k;

                seriesRef.current.update({
                    time: Math.floor(candle.t / 1000),
                    open: parseFloat(candle.o),
                    high: parseFloat(candle.h),
                    low: parseFloat(candle.l),
                    close: parseFloat(candle.c),
                });

                // ✅ Stop loading after first candle received
                if (bookLoading) setBookLoading(false);
            } catch (error) {
                console.error('Error processing WebSocket message:', error);
            }
        };

        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        return () => {
            if (ws.readyState === WebSocket.OPEN) {
                ws.close();
            }
        };
    }, [symbol, interval]);



    const intervals = ['1m', '5m', '15m', '30m', '1h', '4h', '1d'];

    return (
        <div style={{ position: 'relative', padding: '20px', backgroundColor: '#222' }}>


            {bookLoading && (
                <div className="book-loader" style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 10,
                }}>
                    <Bars
                        height="40"
                        width="40"
                        color="#ffc630"
                        ariaLabel="bars-loading"
                        visible={true}
                    />
                </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                <h3 style={{ color: 'white', margin: 0, fontSize: '1em' }}>
                    {symbol}
                    <span style={{
                        marginLeft: '10px',
                        color: isConnected ? '#4CAF50' : '#F44336',
                        fontSize: '0.8em'
                    }}>
                        {/* {isConnected ? '● Live' : '● Disconnected'} */}
                    </span>
                    {lastUpdate && (
                        <span style={{
                            marginLeft: '10px',
                            fontSize: '0.8em',
                            color: '#888'
                        }}>
                            Last update: {lastUpdate}   
                        </span>
                    )}
                </h3>

                <div>
                    <select
                        value={interval}
                        onChange={(e) => setInterval(e.target.value)}
                        style={{
                            padding: '3px 6px',
                            marginRight: '10px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: '1px solid #444',
                            borderRadius: '4px',
                            fontSize: '0.7em'

                        }}
                    >
                        {intervals.map(int => (
                            <option key={int} value={int}>{int}</option>
                        ))}
                    </select>


                </div>
            </div>
            <div
                ref={chartContainerRef}
                style={{
                    width: '100%',
                    height: '400px',
                    backgroundColor: '#fff',
                }}
            />
        </div>
    );
};

export default BinanceOptionsChart;